module.exports = __webpack_public_path__ + "img/749.75f2d98c.gif";